module.exports = __webpack_public_path__ + "static/media/DualShift.fc8b4021.svg";